import styled from 'styled-components'

export const StyledConfirmationFooter = styled.p({
  marginBottom: '1.5rem !important'
})
